module.exports = require("chance");;